import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const YouTubeMusicSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.8 0 27 15"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        clip-rule="evenodd"
        d="m16 8c0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8zm-8-3.6487c2.0122 0 3.6487 1.63653 3.6487 3.6487 0 2.0122-1.6365 3.6487-3.6487 3.6487-2.01217 0-3.6487-1.6365-3.6487-3.6487 0-2.01217 1.63653-3.6487 3.6487-3.6487zm0-.3513c-2.20957 0-4 1.79043-4 4 0 2.2096 1.79043 4 4 4 2.2096 0 4-1.7904 4-4 0-2.20957-1.7904-4-4-4zm2.2812 3.90082-3.43745 2.38038v-4.56245z"
        fill={color}
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default YouTubeMusicSvg
